import type { ButtonProps } from '@mui/material';
import { Button, buttonClasses, styled } from '@mui/material';

const StyledButton = styled(Button)(
  ({ theme }) => `
    & .${buttonClasses.endIcon} {
      margin-inline-start: ${theme.spacing(1)};
      margin-inline-end: -${theme.spacing(0.5)};
    }
  `,
);

const ButtonWithEndIcon = (props: ButtonProps) => <StyledButton {...props} />;

export default ButtonWithEndIcon;
